/* creta-winter.js - gentle snowfall with a visitor on/off toggle */
(function () {
  if (window.__cretaWinter) return;
  window.__cretaWinter = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;
  var KEY = 'creta_snow';
  function pref() { try { return window.localStorage.getItem(KEY) !== 'off'; } catch (e) { return true; } }
  function save(v) { try { window.localStorage.setItem(KEY, v ? 'on' : 'off'); } catch (e) {} }

  function init() {
    var cv = document.createElement('canvas');
    cv.className = 'creta-snow';
    cv.setAttribute('aria-hidden', 'true');
    document.body.appendChild(cv);
    var ctx = cv.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = 0, H = 0;

    var sprite = document.createElement('canvas');
    sprite.width = sprite.height = 32;
    var sctx = sprite.getContext('2d');
    var g = sctx.createRadialGradient(16, 16, 0, 16, 16, 15);
    g.addColorStop(0, 'rgba(255,255,255,0.98)');
    g.addColorStop(0.55, 'rgba(232,247,255,0.9)');
    g.addColorStop(1, 'rgba(140,190,220,0.55)');
    sctx.fillStyle = g;
    sctx.beginPath(); sctx.arc(16, 16, 15, 0, Math.PI * 2); sctx.fill();

    function size() {
      W = window.innerWidth; H = window.innerHeight;
      cv.width = W * dpr; cv.height = H * dpr;
      cv.style.width = W + 'px'; cv.style.height = H + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    size();
    window.addEventListener('resize', size);

    var count = window.innerWidth < 750 ? 32 : 60;
    var flakes = [];
    for (var i = 0; i < count; i++) {
      flakes.push({
        x: Math.random() * W, y: Math.random() * H,
        r: 1.6 + Math.random() * 3.4,
        v: 0.35 + Math.random() * 0.9,
        p: Math.random() * Math.PI * 2,
        a: 0.4 + Math.random() * 0.6
      });
    }

    var on = pref();
    var raf = null;
    function frame() {
      raf = null;
      if (!on) return;
      if (!document.hidden) {
        ctx.clearRect(0, 0, W, H);
        for (var i = 0; i < flakes.length; i++) {
          var f = flakes[i];
          f.y += f.v;
          f.p += 0.012;
          f.x += Math.sin(f.p) * 0.35;
          if (f.y > H + 6) { f.y = -6; f.x = Math.random() * W; }
          if (f.x > W + 6) f.x = -6;
          if (f.x < -6) f.x = W + 6;
          ctx.globalAlpha = f.a;
          ctx.drawImage(sprite, f.x - f.r, f.y - f.r, f.r * 2, f.r * 2);
        }
        ctx.globalAlpha = 1;
      }
      raf = requestAnimationFrame(frame);
    }
    function apply() {
      if (on) { if (!raf) raf = requestAnimationFrame(frame); }
      else { if (raf) cancelAnimationFrame(raf); raf = null; ctx.clearRect(0, 0, W, H); }
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-off', !on);
    }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'creta-snow-toggle';
    btn.setAttribute('aria-label', 'Toggle falling snow');
    btn.innerHTML = '&#10052;';
    btn.addEventListener('click', function () { on = !on; save(on); apply(); });
    document.body.appendChild(btn);
    apply();
  }
  if (document.body) init(); else document.addEventListener('DOMContentLoaded', init);
})();